module.exports = __webpack_public_path__ + "img/mood5.dc485b99.png";